 

import { getFirestore, collection, addDoc, query, where, getDocs, deleteDoc, doc,updateDoc,writeBatch, Timestamp, increment, getDoc,  setDoc  } from 'firebase/firestore';
import { useState } from 'react';


const DEBTS_COLLECTION = "clientDebts";


{/* CANCELLAZIONE tutti ordini  */}
export async function deleteAllOrders() {
  try {
    const db = getFirestore();
    const ordersCollection = collection(db, "orders");
    const querySnapshot = await getDocs(ordersCollection);

    // Itera su tutti i documenti e li elimina
    const deletePromises = querySnapshot.docs.map((docSnapshot) =>
      deleteDoc(doc(db, "orders", docSnapshot.id))
    );

    // Aspetta che tutte le operazioni di eliminazione siano completate
    await Promise.all(deletePromises);

    console.log("Tutti gli ordini sono stati eliminati con successo.");
    return "Tutti gli ordini sono stati eliminati con successo.";
  } catch (error) {
    console.error("Errore durante l'eliminazione degli ordini:", error);
    throw error;
  }
}



{/* Restituisce tutti i clienti  */}
export async function getClients() {
  const db = getFirestore();
  const querySnapshot = await getDocs(collection(db, "clients"));
  return querySnapshot.docs.map((doc) => doc.data().name);
}




{/* Aggiungo ordine  - tasto SalvaOrdini - CLIENTE  */}
export async function addOrderClient(order) {
 // console.log("sono qui", order);
  try {
    const db = getFirestore();
    const documentReference = await addDoc(collection(db, 'orders'), order);
    return documentReference;
  } catch (error) {
    console.error('Errore durante l\'aggiunta dell\'ordine:', error);
    throw error;
  }
}


{/* Ordine esistente, aggiorna ordine */}
export async function updateOrderClient(order,id) {
  try {
    const db = getFirestore();
    const orderRef = doc(db, 'orders',id); // Assumi che order.id contenga l'ID del documento da aggiornare
    await updateDoc(orderRef, order); 
  } catch (error) {
    console.error('Errore durante l\'aggiornamento dell\'ordine:', error);
    throw error;
  }
}


{/* Esiste un ordine per il cliente - CLIENTE  */}
export async function checkOrderByDayMonthYear(cliente, giorno, mese, anno) {
   
  try {
    const db = getFirestore();
    const ordersQuery = query(
      collection(db, "orders"),
      where("cliente", "==", cliente),
      where("giorno", "==", giorno),
      where("mese", "==", mese),
      where("anno", "==", String(anno))
    );

    const ordersQuerySnapshot = await getDocs(ordersQuery);
 
    return ordersQuerySnapshot; // Restituisce sempre un QuerySnapshot, vuoto se non ci sono risultati
  } catch (error) {
    console.error("Errore durante il recupero degli ordini:", error);
    throw error;
  }
}


export async function deleteOrders(orderId) {
  console.log(orderId)
  try {
    if (!orderId) {
      throw new Error("ID ordine mancante.");
    }
    const db = getFirestore();
    const orderRef = doc(db, "orders", orderId); // Usa l'ID per ottenere il riferimento
    await deleteDoc(orderRef);
    console.log("Ordine eliminato con successo!");
  } catch (error) {
    console.error("Errore durante la cancellazione dell'ordine: ", error);
    throw error;
  }
}




{/* Restituisce gli ordini del mese per un dato cliente e mese*/}
export async function getOrderByClientNameAndMonthAndYears(selectedItem, mese, anno) {
  console.log("Cliente selezionato: ", selectedItem, " mese ", mese, " anno", anno);
  try {
    const db = getFirestore();
    const ordersQuery = query(
      collection(db, 'orders'),
      where('cliente', '==', selectedItem),
      where('mese', '==', String(mese)),
      where('anno', '==', String(anno))
    );
    const querySnapshot = await getDocs(ordersQuery);

    if (querySnapshot.empty) {
      console.log("Nessun documento trovato per la query.");
    } else {
      querySnapshot.forEach((doc) => {
      //  console.log("Documento trovato:", doc.data());
      });
    }

    return querySnapshot;
  } catch (error) {
    console.error("Errore durante il recupero degli ordini per mese e anno: ", error);
    throw error;
  }
}


{/* Aggiungo un Cliente  - tasto addclient  */}
export async function addClient(clientName) {
  try {     
    const db = getFirestore();
    const clientData = { name: clientName };
    const documentReference = await addDoc(collection(db, 'clients'), clientData);
    return documentReference;
  } catch (error) {
    console.error('Errore durante l\'aggiunta del cliente:', error);
    throw error;
  }
}


{/* Cancello un Cliente con i suoi ordini da Client - tasto deleteClient  */}
export async function deleteOrdersAndClient(clientNameToDelete) {
  try {
    const db = getFirestore();

    // Cancella ordini
    const ordersQuery = query(collection(db, 'orders'), where('cliente', '==', clientNameToDelete));
    const ordersSnapshot = await getDocs(ordersQuery);
    await Promise.all(ordersSnapshot.docs.map((doc) => deleteDoc(doc.ref)));

    // ✅ Cancella il saldo precedente dalla collection clientDebts
    const debtQuery = query(collection(db, 'clientDebts'), where('clientName', '==', clientNameToDelete));
    const debtSnapshot = await getDocs(debtQuery);
    await Promise.all(debtSnapshot.docs.map((doc) => deleteDoc(doc.ref)));

    // Cancella cliente
    const clientQuery = query(collection(db, 'clients'), where('name', '==', clientNameToDelete));
    const clientSnapshot = await getDocs(clientQuery);
    await Promise.all(clientSnapshot.docs.map((doc) => deleteDoc(doc.ref)));

    return { success: true };
  } catch (error) {
    console.error('Errore durante la cancellazione:', error);
    throw error;
  }
}

{ /* Aggiungi Spesa  */}
export async function addCosts(addCostsDesc, costTotal, day, month, year) {
  try {
    const db = getFirestore();
    const CostsData = {
      descrizione: addCostsDesc,
      totale: parseFloat(costTotal),
      giorno: day,
      mese: month,
      anno: year, // Aggiungi l'anno
    };

    const documentReference = await addDoc(collection(db, "costs"), CostsData);
    return documentReference;
  } catch (error) {
    console.error("Errore durante l'aggiunta della spesa:", error);
    throw error;
  }
}


{ /* Controllo  Spesa per data */}
export async function getCostsByDate(giorno, mese, anno) {
  try {
    const db = getFirestore();
    const q = query(
      collection(db, "costs"),
      where("giorno", "==", giorno),
      where("mese", "==", mese),
      where("anno", "==", anno)
    );

    const querySnapshot = await getDocs(q);
    if (!querySnapshot.empty) {
      // Ritorna il primo documento trovato
      const docData = querySnapshot.docs[0];
      return { id: docData.id, ...docData.data() };
    }
    return null; // Nessuna spesa trovata per quel giorno
  } catch (error) {
    console.error("Errore durante il recupero delle spese:", error);
    throw error;
  }
}

{ /* Aggiorno la spesa */}
export async function updateCosts(id, updatedData) {
  try {
    const db = getFirestore();
    const docRef = doc(db, "costs", id);
    await updateDoc(docRef, updatedData);
    return true;
  } catch (error) {
    console.error("Errore durante l'aggiornamento delle spese:", error);
    throw error;
  }
}


{ /* Recupero totale spese mese */}
export async function getCosts(giorno, mese, anno) {
  try {
    const db = getFirestore();
    const costsRef = collection(db, "costs");

    const meseStr = String(mese);
    const annoStr = String(anno);

    // Debug: Verifica se giorno è nullo o meno
   // console.log("Parametri passati:", { giorno, mese, anno });

    let q;
    if (giorno) {
      const giornoStr = String(giorno);
      q = query(
        costsRef,
        where("anno", "==", annoStr),
        where("mese", "==", meseStr),
        where("giorno", "==", giornoStr)
      );
    } else {
      q = query(costsRef, where("anno", "==", annoStr), where("mese", "==", meseStr));
    }

    const querySnapshot = await getDocs(q);

    const costs = [];
    querySnapshot.forEach((doc) => {
     // console.log("Documento trovato:", doc.data()); // Debug
      costs.push(doc.data());
    });

    return costs;
  } catch (error) {
    console.error("Errore durante il recupero delle spese:", error);
    throw error;
  }
}


{ /* Recupero totale spese giorno */}
export async function getDayOrders(giorno, mese, anno) {
  try {
    const db = getFirestore();
    const ordersRef = collection(db, "orders");

    const giornoStr = String(giorno);
    const meseStr = String(mese);
    const annoStr = String(anno);

    const q = query(
      ordersRef,
      where("anno", "==", annoStr),
      where("mese", "==", meseStr),
      where("giorno", "==", giornoStr)
    );

    const querySnapshot = await getDocs(q);

    const orders = [];
    querySnapshot.forEach((doc) => {
      console.log("Documento Ordine:", doc.data()); // Debug
      orders.push(doc.data());
    });

    return orders;
  } catch (error) {
    console.error("Errore durante il recupero degli ordini del giorno:", error);
    throw error;
  }
}

 
{ /* Recupero totale ordini mese anno per cliente */}
export async function getClientEarnings1(clientName, mese, anno) {
  try {
    const db = getFirestore();

    const meseStr = String(mese);
    const annoStr = String(anno);

  //  console.log(`Ordini ${clientName}, mese: ${meseStr}, anno: ${annoStr}`);

    const ordersQuery = query(
      collection(db, "orders"),
      where("cliente", "==", clientName),
      where("mese", "==", meseStr),
      where("anno", "==", annoStr)
    );

    const ordersSnapshot = await getDocs(ordersQuery);

    // Somma solo i valori del campo `totale`
    const totalEarnings = ordersSnapshot.docs.reduce((total, doc) => {
      const orderData = doc.data();
      return total + parseFloat(orderData.totale || 0);
    }, 0);

   // console.log(`Totale per ${clientName}: ${totalEarnings.toFixed(2)} €`);

    return totalEarnings.toFixed(2);
  } catch (error) {
    console.error(`Errore durante il recupero degli ordini per ${clientName}:`, error);
    throw error;
  }
}






{ /* Recupero totale ordini giorno mese anno per cliente */}
export async function getClientDailyEarnings(clientName, mese, anno, giorno) {
  try {
    const db = getFirestore();

    // Usa i parametri direttamente, senza formattazione
  //  console.log(`Eseguo la query per ${clientName}: giorno=${giorno}, mese=${mese}, anno=${anno}`  );

    // Query per cliente, mese, anno e giorno
    const ordersQuery = query(
      collection(db, "orders"),
      where("cliente", "==", clientName),
      where("mese", "==", String(mese)), // Usa direttamente mese
      where("anno", "==", String(anno)), // Usa direttamente anno
      where("giorno", "==", String(giorno)) // Usa direttamente giorno
    );

    const ordersSnapshot = await getDocs(ordersQuery);

    // Debug: stampa i dati recuperati
  //  console.log(`Dati recuperati per ${clientName}:`,  ordersSnapshot.docs.map((doc) => doc.data())  );

    // Somma i totali giornalieri
    const totalEarnings = ordersSnapshot.docs.reduce((total, doc) => {
      const orderData = doc.data();
      return total + parseFloat(orderData.totale || 0);
    }, 0);

 //   console.log(`Totale guadagni per ${clientName}: ${totalEarnings}`);
    return totalEarnings.toFixed(2);
  } catch (error) {
    console.error(
      `Errore durante il recupero degli ordini giornalieri per ${clientName}:`,
      error
    );
    throw error;
  }
}


// -----------------


// Cancella ordini per mese e anno
export async function deleteAllOrdersByDayAndMonth(mese, anno) {
 // console.log( " Delete Orderes mese " + mese + "anno" , anno)
  try {
    const db = getFirestore();
    const ordersQuery = query(
      collection(db, "orders"),
      where("mese", "==", String(mese)),
      where("anno", "==", String(anno))
    );

    const querySnapshot = await getDocs(ordersQuery);
    const batchPromises = querySnapshot.docs.map((docSnapshot) =>
      deleteDoc(doc(db, "orders", docSnapshot.id))
    );

    await Promise.all(batchPromises);
    console.log("Ordini cancellati con successo.");
  } catch (error) {
    console.error("Errore durante la cancellazione degli ordini:", error);
    throw error;
  }
}

// Cancella spese per mese e anno
export async function deleteAllCostsByDayAndMonth(mese, anno) {
//  console.log( " Delete Costs mese " + mese + "anno" , anno)
  try {
    const db = getFirestore();
    const costsQuery = query(
      collection(db, "costs"),
      where("mese", "==", String(mese)),
      where("anno", "==", String(anno))
    );

    const querySnapshot = await getDocs(costsQuery);
    const batchPromises = querySnapshot.docs.map((docSnapshot) =>
      deleteDoc(doc(db, "costs", docSnapshot.id))
    );

    await Promise.all(batchPromises);
    console.log("Spese cancellate con successo.");
  } catch (error) {
    console.error("Errore durante la cancellazione delle spese:", error);
    throw error;
  }
}

{
  /* Restituisce gli ordini del mese, del giorno di tutti i clienti*/
}
export async function getFindOrderByDayAndMonth(day, month) {
//  console.log("Ordini del giorno ", day, " e del mese ", month);
  try {
    const db = getFirestore();
    const ordersQuery = query(
      collection(db, "orders"),
      where("giorno", "==", String(day)),
      where("mese", "==", String(month))
    );

    const querySnapshot = await getDocs(ordersQuery);
    const results = {};

    querySnapshot.forEach((doc) => {
      const data = doc.data();
      results[doc.id] = {
        clientName: data.clientName,
        totalPrice: data.totalPrice,
        totalDeposit: data.deposit,
      };
     
    });

    return results;
  } catch (error) {
    console.error(
      "Errore durante il recupero degli ordini per mese e giorno: ",  error);
    throw error;
  }
}



export async function getClientsData() {
  try {
    const db = getFirestore();

    // Ottieni tutti i documenti dalla collezione "clients"
    const querySnapshot = await getDocs(collection(db, 'clients'));

    // Mappa i documenti e ottieni i dati
    const clientsData = querySnapshot.docs.map((doc) => doc.data().name);

    return clientsData;
  } catch (error) {
    console.error('Errore durante il recupero dei clienti:', error);
    throw error;
  }
}


{/* Aggiungi la categoria*/}
export async function addCategory(nuovaCategoria) {
  try {
    const db = getFirestore();

    const docRef = await addDoc(collection(db, "categorie"), {
      tipo: nuovaCategoria,
    });

    return { id: docRef.id, tipo: nuovaCategoria };
  } catch (error) {
    console.error("Errore in aggiunta della categoria:", error);
    throw error;
  }
}


{/* Rimuovi la categoria*/}
export async function deleteCategory(id, tipo) {
  try {
    const db = getFirestore();

    console.log(tipo)

    // Elimina la categoria
    await deleteDoc(doc(db, "categorie", id));

    // Recupera tutte le voci di menu con la categoria da eliminare
    const menuQuery = query(
      collection(db, "menu"),
      where("categoria", "==", tipo)
    );
    const menuSnapshot = await getDocs(menuQuery);

    // Elimina le voci di menu corrispondenti
    const batch = writeBatch(db); // Usa un batch per eliminazioni multiple
    menuSnapshot.forEach((menuDoc) => {
      batch.delete(menuDoc.ref);
    });
    await batch.commit();

    return id;
  } catch (error) {
    console.error("Errore in cancellazione della categoria e dei menu:", error);
    throw error;
  }
}


{/* Aggiungi allergene*/}
export async function addAllergens(nuovoAllergene) {
  try {
    const db = getFirestore();

    const docRef = await addDoc(collection(db, "allergeni"), {
      nome: nuovoAllergene,
    });

    return { id: docRef.id, nome: nuovoAllergene };
  } catch (error) {
    console.error("Errore nell'aggiunta dell'allergene:", error);
    throw error;
  }
}



{/* Rimuovi allergene*/}
export async function deleteAllergens(id) {
  try {
    const db = getFirestore();

    await deleteDoc(doc(db, "allergeni", id));

    return id;
  } catch (error) {
    console.error("Errore in cancellazione dell'allergene", error);
    throw error;
  }
}



{/* Aggiungi menu*/}
export async function addMenu(menuItem) {
  try {
    const db = getFirestore();

    const nuovoItem = {
      categoria: menuItem.categoria,
      nome: menuItem.nome,
      ingredienti: menuItem.ingredienti || "",
      allergeni: menuItem.allergeni,
      prezzo: parseFloat(menuItem.prezzo),
      note: menuItem.note || "",
    };

    const docRef = await addDoc(collection(db, "menu"), nuovoItem);
    return { id: docRef.id, ...nuovoItem };
  } catch (error) {
    console.error("Errore nella creazione del menu item:", error);
    throw error;
  }
}


{/* Rimuovi Menu*/}
export async function deleteMenu(id) {
  try {
    const db = getFirestore();
    await deleteDoc(doc(db, "menu", id));
  } catch (error) {
    console.error("Errore durante l'eliminazione del menu item:", error);
    throw error;
  }
}


{/* ---------------------------------------------  */}


// Sostituisce la vecchia getFindOrderByDayAndMonth(day, month)
 
export const getOrdersForMonth = async (month, year) => {
    const db = getFirestore();
    const yearStr = String(year);
    const monthStr = String(month); 

    try {
        // La query ora filtra usando i campi stringa presenti nel tuo DB
        const q = query(
            collection(db, "orders"),
            where("anno", "==", yearStr),
            where("mese", "==", monthStr)
        );
        
        const querySnapshot = await getDocs(q);
        
        return querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })); 
        
    } catch (error) {
        console.error("Errore nel recupero degli ordini del mese:", error);
        return [];
    }
};



export async function getClientEarnings(clientName, mese, anno) {
  try {
    const db = getFirestore();

    const meseStr = String(mese);
    const annoStr = String(anno);

    const ordersQuery = query(
      collection(db, "orders"),
      where("cliente", "==", clientName),
      where("mese", "==", meseStr),
      where("anno", "==", annoStr)
    );

    const ordersSnapshot = await getDocs(ordersQuery);

    const totals = ordersSnapshot.docs.reduce((acc, doc) => {
      const orderData = doc.data();
      
      // 1. Somma Ordini (variabili 'varie' e 'pane')
      const orderValue = parseFloat(orderData.varie || 0) + parseFloat(orderData.pane || 0);
      acc.totalOrders += orderValue;
      
      // 2. Somma Acconti
      const downPaymentValue = parseFloat(orderData.acconto || 0);
      acc.totalDownPayments += downPaymentValue;
      
      // 3. Somma Differenza (campo 'totale')
      const differenceValue = parseFloat(orderData.totale || 0);
      acc.totalDifference += differenceValue;
      
      return acc;
    }, { totalOrders: 0, totalDownPayments: 0, totalDifference: 0 });

    // Restituisce un oggetto con i totali formattati
    return {
      totalOrders: totals.totalOrders.toFixed(2),
      totalDownPayments: totals.totalDownPayments.toFixed(2),
      totalDifference: totals.totalDifference.toFixed(2),
    };

  } catch (error) {
    console.error(`Errore durante il recupero degli ordini per ${clientName}:`, error);
    throw error;
  }
}






// fe-gestionale-nuovo-forno\src\components\utility\EndPointGoogleFirebase.js

/**
 * Funzione di simulazione per ottenere la media dei voti e il conteggio totale.
 * @returns {Promise<{averageRating: number, totalReviews: number}>}
 */
/**
 * Legge la media e il totale voti dal DB
 */
export const fetchRatingStats = async () => {
   const db = getFirestore();
    try {
        const statsRef = doc(db, "ratings", "stats");
        const statsSnap = await getDoc(statsRef);

        if (!statsSnap.exists()) {
            // Se la tabella non esiste la creo
            await setDoc(statsRef, {
                totalReviews: 0,
                totalRatingSum: 0
            });

            return {
                averageRating: 0,
                totalReviews: 0
            };
        }

        const data = statsSnap.data();

        const averageRating =
            data.totalReviews > 0
                ? data.totalRatingSum / data.totalReviews
                : 0;

        return {
            averageRating,
            totalReviews: data.totalReviews
        };

    } catch (error) {
        console.error("Errore lettura stats Firebase:", error);
        return {
            averageRating: 0,
            totalReviews: 0
        };
    }
};

/**
 * Funzione di simulazione per inviare il voto dell'utente al database.
 * @param {number} rate - Il voto (1-5) dato dall'utente.
 * @returns {Promise<boolean>}
 */
/**
 * Salva un voto nel database aggiornando i valori
 */
export const submitUserRating = async (rate) => {
   const db = getFirestore();
    try {
        const statsRef = doc(db, "ratings", "stats");

        // Aggiorna in modo atomico (evita sovrascritture)
        await updateDoc(statsRef, {
            totalReviews: increment(1),
            totalRatingSum: increment(rate)
        });

        return true;

    } catch (error) {

        // Se il documento non esiste ancora → lo creiamo
        if (error.code === "not-found") {
            const statsRef = doc(db, "ratings", "stats");
            await setDoc(statsRef, {
                totalReviews: 1,
                totalRatingSum: rate
            });
            return true;
        }

        console.error("Errore salvataggio voto Firebase:", error);
        return false;
    }
};



 export const getAllClientDebts = async () => {
    const db = getFirestore();
    try {
        const snapshot = await getDocs(collection(db, "clientDebts"));
        const debts = {};
        snapshot.forEach((doc) => {
            const data = doc.data();
            debts[data.clientName] = parseFloat(data.debt || 0);
        });
        return debts;
    } catch (error) {
        console.error("Errore recupero debiti clienti:", error);
        return {};
    }
};
 
export const setClientDebt = async (clientName, debt) => {
    const db = getFirestore();
    try {
        const debtValue = isNaN(parseFloat(debt)) ? 0 : parseFloat(debt);
        console.log(debtValue);
        const q = query(
            collection(db, "clientDebts"),
            where("clientName", "==", clientName)
        );
        const snapshot = await getDocs(q);
        const updatedAt = new Date().toISOString().slice(0, 7); // "YYYY-MM"
 
        if (snapshot.empty) {
            await addDoc(collection(db, "clientDebts"), {
                clientName,
                debt: debtValue,
                updatedAt,
            });
        } else {
            await updateDoc(doc(db, "clientDebts", snapshot.docs[0].id), {
                debt: debtValue,
                updatedAt,
            });
        }
        return debtValue;
    } catch (error) {
        console.error("Errore salvataggio debito cliente:", error);
        return false;
    }
};
 
export const getClientDebt = async (clientName) => {
    const db = getFirestore();
    try {
        const q = query(
            collection(db, "clientDebts"),
            where("clientName", "==", clientName)
        );
        const snapshot = await getDocs(q);
        if (snapshot.empty) return 0;
        return parseFloat(snapshot.docs[0].data().debt || 0);
    } catch (error) {
        console.error("Errore recupero debito cliente:", error);
        return 0;
    }
};


// Controlla se esistono ordini per un dato mese/anno
export async function hasOrdersForMonth(mese, anno) {
  try {
    const db = getFirestore();
    const q = query(
      collection(db, 'orders'),
      where('mese', '==', String(mese)),  // ← converti in stringa
      where('anno', '==', String(anno))   // ← converti in stringa
    );
    const snapshot = await getDocs(q);
    return !snapshot.empty;
  } catch (error) {
    console.error('Errore controllo ordini mese:', error);
    return false;
  }
}

export async function hasCostsForMonth(mese, anno) {
  try {
    const db = getFirestore();
    const q = query(
      collection(db, 'costs'),
      where('mese', '==', String(mese)),  // ← converti in stringa
      where('anno', '==', String(anno))   // ← converti in stringa
    );
    const snapshot = await getDocs(q);
    return !snapshot.empty;
  } catch (error) {
    console.error('Errore controllo spese mese:', error);
    return false;
  }
}